import React from "react";
import { Select } from "antd";
import { useCurrency } from "./CurrencyContext";

const { Option } = Select;

const CurrencySelector = () => {
  const { currency, setCurrency } = useCurrency();

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <span style={{ fontWeight: "bold", color: 'black' }}>Currency:</span>
      <Select
        value={currency}
        onChange={(value) => setCurrency(value)}
        style={{ width: 80 }}
      >
        <Option value="PKR">PKR</Option>
        <Option value="USD">USD</Option>
        <Option value="GBP">GBP</Option>
        <Option value="EUR">EUR</Option>
      </Select>
    </div>
  );
};

export default CurrencySelector;
